import { i18n } from '@/packages/i18n';

import { useGlobalStore } from '@/stores/globalStore';
import { useNotificationStore } from '@/stores/components/notificationStore';

import useMerchApiEndpoints from '@/composables/api/useMerchApiEndpoints';
import useTheme from '@/composables/ui/useTheme';
import useMiddleware from '@/router/useMiddleware';
import useLocalStorage from "@/composables/storage/useLocalStorage.js";

export default () => {
  const globalStore = useGlobalStore();
  const notificationStore = useNotificationStore();
  const { handleMerchantAllowDirectVisitFlow } = useMiddleware();
  const { getMerchSettings, getNotificationSettings } = useMerchApiEndpoints();
  const { bindLocalStorage } = useLocalStorage();
  const { t } = i18n.global;

  const checkUrlForMerchUrls = (route) => {
    const { returnUrl } = route.query;

    if (returnUrl) {
      globalStore.global.merchant.returnUrl = returnUrl;
      globalStore.global.merchant.returnMessage = `${t('merchantSettings.label.returnMessage')} ${globalStore.global.merchant.name}`;
      globalStore.global.merchant.returnUrlIsFromQuery = true;
      // to account for for 3rd party redirects
      bindLocalStorage('merchReturnUrl', globalStore.global.merchant.returnUrl);
    }
  };

  const getMerchantSettings = async (route) => {
    const { updateThemeFromMerchant } = useTheme();
    let settings = await getMerchSettings();
    settings = settings.data;
    globalStore.setMerchantSettings(settings);
    updateThemeFromMerchant(settings.theme);
    checkUrlForMerchUrls(route);
    handleMerchantAllowDirectVisitFlow(settings);
  };

  const getNotifications = async () => {
    const {
      data: { order, orderStatus },
    } = await getNotificationSettings();
    notificationStore.setBanner(order, orderStatus);
  };

  return {
    getMerchantSettings,
    getNotifications,
  };
};
